// src/components/user/authentication/LoginForm.jsx
import React, { useState, useContext, useEffect } from "react";
import { FaGoogle, FaFacebookF, FaGithub, FaLinkedinIn } from "react-icons/fa";
import { FiArrowRight, FiEye, FiEyeOff } from "react-icons/fi";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import { useNavigate } from "react-router-dom";

const LoginForm = ({ autoLoginCredentials, onAutoLoginHandled }) => {
  const navigate = useNavigate();
  const {
    baseUrl, setAuthToken, setLoggedInCustomer, setIsLoggedIn, setLoggedInRental,
  } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errormessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (autoLoginCredentials?.email && autoLoginCredentials?.password) {
      autoLogin(autoLoginCredentials.email, autoLoginCredentials.password);
      onAutoLoginHandled && onAutoLoginHandled();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoLoginCredentials]);

  const handleLoginSuccess = (response) => {
    localStorage.setItem("authToken", response.data.token);
    setAuthToken(response.data.token);
    setIsLoggedIn(true);
    localStorage.removeItem("LoggedInRental");
    setLoggedInRental(null);
    localStorage.setItem("LoggedInCustomer", JSON.stringify(response.data.customer));
    setLoggedInCustomer(response.data.customer);
    setLoading(false);

    const redirectUrl = localStorage.getItem("redirectAfterLogin");
    localStorage.removeItem("redirectAfterLogin");
    setTimeout(() => navigate(redirectUrl || "/"), 300);
  };

  const autoLogin = (savedEmail, savedPassword) => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("email", savedEmail);
    formdata.append("password", savedPassword);

    axios.post(`${baseUrl}/customer/login`, formdata)
      .then(handleLoginSuccess)
      .catch(() => setLoading(false)); // auto-login fail ho to chup chap manual login pe chor do
  };

  const customerLogin = () => {
    if (!email || !password) {
      setErrorMessage("Email and password required");
      return;
    }
    setLoading(true);
    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("password", password);

    axios.post(`${baseUrl}/customer/login`, formdata)
      .then(handleLoginSuccess)
      .catch((error) => {
  setLoading(false);
  if (error.response?.status === 404) {
    setErrorMessage("This account is not registered. Please register first...");
    setTimeout(() => navigate("/auth", { state: { isLogin: false } }), 2000);
  } else if (error.response?.status === 401) {
    setErrorMessage("Invalid Email or Password");
  } else {
    setErrorMessage("Login failed, please try again");
  }
});
  };

  return (
    <>
      <h3>Login</h3>
      <input type="email" placeholder="Email" value={email}
        onChange={(e) => setEmail(e.target.value)} />

      <div style={{ position: "relative" }}>
        <input
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          value={password}
          style={{ width: "100%", paddingRight: "40px" }}
          onChange={(e) => setPassword(e.target.value)}
        />
        <span onClick={() => setShowPassword(!showPassword)}
          style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#888" }}>
          {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
        </span>
      </div>

      <p style={{ textAlign: "right", marginTop: "8px" }}>
        <span onClick={() => navigate("/general/forgot-password/customer")}
          style={{ color: "#FDB714", fontWeight: "600", cursor: "pointer", textDecoration: "underline", fontSize: "0.85rem" }}>
          Forgot Password?
        </span>
      </p>

      {errormessage && <p style={{ color: "red", marginTop: "10px", fontSize: "14px" }}>{errormessage}</p>}

      <button type="button" onClick={customerLogin}
        className={`main-btn ${loading ? "loading" : ""}`} disabled={loading}>
        {loading ? (<><span className="customer-spinner"></span><span>Loging In...</span></>) :
          (<><span>LogIn</span><FiArrowRight className="customer-admin-icon" /></>)}
      </button>
    </>
  );
};

export default LoginForm;